import * as types from './types'
import latestApi from '../api'

export const actions = {
    async [types.LATEST_FETCH]({commit}, data = null) {
        commit(types.LATEST_SET_LOADING, true)
        const response = await latestApi.all(data)
        commit(types.LATEST_OBTAIN, response.data.data)
        commit(types.LATEST_META, response.data.meta)
        commit(types.LATEST_SET_LOADING, false)
    },
}
